// extracted by mini-css-extract-plugin
export default {"header":"ModalLauncher_header__XkvCO","close":"ModalLauncher_close__WUCyx","wide":"ModalLauncher_wide__sqAWL"};